










import Vue from 'vue';
import BaseSelect from '../components/BaseSelect.vue';
import { Company } from '@/api/companies/company.model';
import CompaniesService from '@/api/companies/companies.service';
import { Filter } from '@/shared/types/filter.class';
import Component from 'vue-class-component';
import { VModel, Prop, Watch } from 'vue-property-decorator';
import { PaginateResult } from '@/shared/types/paginate-result.class';

const companiesService = new CompaniesService();

// The @Component decorator indicates the class is a Vue component
@Component({
  components: { BaseSelect },
})
export default class Companieselect extends Vue {
  @VModel({ type: Array })
  data!: Company[];

  @Prop()
  multiple!: boolean;

  @Prop({
    type: Object,
    default: () => new Filter(),
  })
  filter!: Filter;

  localFilter: Filter;

  @Watch('filter', { immediate: true, deep: true })
  onFilterChanged() {
    this.localFilter = this.filter.copy();
  }

  async fetchCompanies(filter: Filter): Promise<PaginateResult<Company>> {
    return companiesService.fetch(filter);
  }
}
